
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { TicketInterface } from '@/services/QC-V2/ticket/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class TicketDetails extends Vue {
  @Prop() private ticket!: TicketInterface;
  @Prop({ default: false }) private initiallyCollapsed!: boolean;

  private collapsed: boolean = true;

  private ticketPriorities: string[] = [
    'LOW',
    'NORMAL',
    'HIGH',
    'CRITICAL',
  ];

  private created(): void {
    this.collapsed = this.initiallyCollapsed;
  }
}
